import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const VideoListBlock = styled.div`
  overflow: hidden;
  padding: 10px;
  min-width: 20%;
`;

const VideoListMenu = styled.div`
  margin-bottom: 20px;
`;

const SectionHeader = styled.div`
  font-size: 1rem;
  font-weight: bold;
  padding: 10px;
  margin-bottom: 0;
  border-radius: 5px 5px 0px 0px;
  color: white;
  background-color: ${(props) => props.colors.componentHeaderBackground};
`;

const ResourceList = styled.ul`
  list-style-type: none;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 0px 0px 5px 5px;
  background-color: ${(props) => props.colors.cardBackground};
  margin-top: 0;
`;

const ResourceItem = styled.li`
  margin-bottom: 8px;
`;

const GenreButton = styled.button`
  background: none;
  border: none;
  padding: 4px 0;
  width: 100%;
  text-align: left;
  color: ${({ active }) => (active ? '#195174' : '#333')};
  text-decoration: ${({ active }) => (active ? 'underline' : 'none')};
  font-size: 12px;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const EmptyState = styled.li`
  margin: 0;
  font-size: 12px;
  color: #555;
`;

const SubscriptionVideosGenre = ({ colors, onGenreSelect, selectedGenre }) => {
  const subscriptionVideosData = useSelector(
    (state) => state.auth.subscription_videos
  );
  const isValidCollection =
    subscriptionVideosData &&
    typeof subscriptionVideosData === 'object' &&
    !Array.isArray(subscriptionVideosData);
  const genres = isValidCollection
    ? Object.keys(subscriptionVideosData).sort((a, b) =>
        a.localeCompare(b, undefined, { sensitivity: 'base' })
      )
    : [];

  return (
    <VideoListBlock>
      <VideoListMenu>
        <SectionHeader colors={colors}>Subscription Videos</SectionHeader>
        <ResourceList colors={colors}>
          {genres.length ? (
            genres.map((genreKey) => (
              <ResourceItem key={genreKey}>
                <GenreButton
                  type="button"
                  active={selectedGenre === genreKey}
                  onClick={() => onGenreSelect && onGenreSelect(genreKey)}
                >
                  {genreKey}
                </GenreButton>
              </ResourceItem>
            ))
          ) : (
            <EmptyState>No subscription videos available.</EmptyState>
          )}
        </ResourceList>
      </VideoListMenu>
    </VideoListBlock>
  );
};

export default SubscriptionVideosGenre;
